<template>
  <div>
    <!-- BOC:[error] -->
    <AError :api="api"></AError>
    <!-- EOC -->
    <!-- BOC:[form] -->
    <v-form ref="form" lazy-validation @submit.prevent="validate">
      <v-card>
        <v-card-title>New Rule</v-card-title>
        <v-card-text>
          <template>
            <Lang
              :value="form['lang']"
              :callbackSelect="selectLang"
              @input="form['lang'] = $event"
            />
          </template>
          <template>
            <FormInput :value="form['text']" @input="form['text'] = $event" />
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$router.go(-1)"> Cancel </v-btn>
          <v-btn color="primary" :loading="api.isLoading" @click="validate">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import Lang from "@/components/Moderator/EventRule/Lang";
import FormInput from "@/components/Moderator/EventRule/FormInput";

import { mapState } from "vuex";
export default {
  props: ["self", "role", "model", "url", "action", "callbackSuccess"],
  components: {
    Lang,
    FormInput,
  },
  computed: mapState({
    school: (state) => state.school.data,
  }),
  data: () => ({
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[form]
    form: {
      lang: null,
      text: null,
    },
    fields: [],
    rules: {},
    //EOC
  }),
  mounted() {
    this.form.lang = this.$_getLocale();
    this.selectLang(this.$_getLocale())
  },
  created() {
    //BOC:[api]
    this.api.url = this.url;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.api.error = null;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.callbackSuccess(resp);
    };
    //EOC
  },
  methods: {
    selectLang(val) {
      if (val == "en") {
        this.form.text = `
      <h1>Event Rule!</h1>
      <p>Here write <strong>event rules</strong></p>
    `;
      } else if (val == "zh") {
        this.form.text = `
      <h1>活动规则！</h1>
      <p>A这里写<strong>事件规则</strong></p>
    `;
      }else   if (val == "ms") {
        this.form.text = `
      <h1>Peraturan Acara!</h1>
      <p>Di sini tulis <strong>peraturan acara</strong></p>
    `;
      }
    },
    //BOC:[form]
    validate() {
      this.api.callbackReset();
      if (this.$refs.form.validate()) {
        this.submit();
      } else {
        this.api.callbackError("Please check the form.");
      }
    },
    submit() {
      this.api.params = this.$_.clone(this.form);
      this.$api.fetch(this.api);
    },
    //EOC
  },
};
</script>

<style>
</style>